// Legacy Business Profile tabs: Location Info · Business Hours · Branding.
export const BUSINESS_PROFILE_TABS = [
  { label: 'Location Info', to: '/l/$slug/settings/location/business-profile' },
  { label: 'Business Hours', to: '/l/$slug/settings/location/business-profile/business-hours' },
  { label: 'Branding', to: '/l/$slug/settings/location/business-profile/branding' },
] as const;
